class BuyXGetY extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.getProduct = this.dataset.getProduct;
    this.buyProduct = this.dataset.buyProduct;
    this.buyCollection = this.dataset.buyCollection;

    this.cartItems = document.querySelector('cart-items');
    if (!this.cartItems) return;

    // If collection is set, fetch collection products first
    if (this.buyCollection && this.buyCollection !== 'undefined') {
      this.fetchCollectionProducts().then(() => {
        console.log('Collection variant IDs loaded:', this.collectionVariantIds);
        this.checkCart();
      });
    } else {
      this.checkCart();
    }
  }

  async fetchCollectionProducts() {
    try {
      // Use Shopify's storefront API approach - fetch collection page with products
      const response = await fetch(`/collections/${this.buyCollection}/products.json`);
      
      if (!response.ok) {
        console.error('Failed to fetch collection products, falling back to HTML parsing');
        // Fallback: fetch collection page and parse HTML
        const html = await fetch(`/collections/${this.buyCollection}`).then(r => r.text());
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        this.collectionVariantIds = this.extractVariantIdsFromHTML(doc);
        console.log('Extracted variant IDs from HTML:', this.collectionVariantIds);
        return;
      }

      const data = await response.json();
      this.collectionVariantIds = data.products.flatMap(product => 
        product.variants.map(variant => variant.id.toString())
      );
      console.log('Fetched collection products successfully:', this.collectionVariantIds);
      
    } catch (error) {
      console.error('Error fetching collection products:', error);
      this.collectionVariantIds = [];
    }
  }

  extractVariantIdsFromHTML(doc) {
    const variantIds = [];
    
    // Try multiple selectors to find variant IDs
    const productForms = doc.querySelectorAll('form[action*="/cart/add"]');
    
    productForms.forEach(form => {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        variantIds.push(variantInput.value);
      }
    });

    // Also try data attributes on product cards
    const productCards = doc.querySelectorAll('[data-product-id]');
    productCards.forEach(card => {
      const variantId = card.dataset.productId;
      if (variantId && !variantIds.includes(variantId)) {
        variantIds.push(variantId);
      }
    });
    
    return variantIds;
  }

  validateGiftItem(cart_items, gift_variant_id) {
    return cart_items.find(line_item => line_item.id == gift_variant_id) ? true : false;
  }

  validateRequiredItem(cart_items, required_variant_id) {
    // If collection is set, check if any item in cart is from the collection
    if (this.buyCollection && this.buyCollection !== 'undefined' && this.collectionVariantIds && this.collectionVariantIds.length > 0) {
      const hasCollectionItem = cart_items.some(line_item => 
        this.collectionVariantIds.includes(line_item.id.toString())
      );
      console.log('Checking collection items. Has collection item:', hasCollectionItem);
      return hasCollectionItem;
    }
    
    // Otherwise, check for specific product
    if (required_variant_id && required_variant_id !== 'undefined') {
      const hasProduct = cart_items.find(line_item => line_item.id == required_variant_id) ? true : false;
      console.log('Checking single product. Has product:', hasProduct);
      return hasProduct;
    }
    
    return false;
  }

  getGiftItem(cart_items, gift_variant_id) {
    return cart_items.find(line_item => line_item.id == gift_variant_id && line_item.final_line_price === 0);
  }

  getRequiredQuantity(cart_items, required_variant_id) {
    // If collection is set, return 1 (max one free gift regardless of quantity)
    if (this.buyCollection && this.buyCollection !== 'undefined' && this.collectionVariantIds && this.collectionVariantIds.length > 0) {
      const hasAnyCollectionItem = cart_items.some(line_item => 
        this.collectionVariantIds.includes(line_item.id.toString())
      );
      console.log('Collection has any item:', hasAnyCollectionItem, '- returning quantity: 1');
      return hasAnyCollectionItem ? 1 : 0;
    }
    
    // Otherwise, get quantity of specific product (matches quantity for single product)
    if (required_variant_id && required_variant_id !== 'undefined') {
      const item = cart_items.find(line_item => line_item.id == required_variant_id);
      const quantity = item ? item.quantity : 0;
      console.log('Single product quantity:', quantity);
      return quantity;
    }
    
    return 0;
  }

  getGiftItemIndex(cart_items, gift_variant_id) {
    if (!this.validateGiftItem(cart_items, gift_variant_id)) return null;
    return cart_items.findIndex(line_item => line_item.id == gift_variant_id && line_item.final_line_price === 0) + 1;
  }

  updateMinBogoQuantity(cart_items) {
    const requiredQuantity = this.getRequiredQuantity(cart_items, this.buyProduct);
    const giftItemIndex = this.getGiftItemIndex(cart_items, this.getProduct);

    giftItemIndex == null ? this.checkCart() : this.cartItems.updateQuantity(giftItemIndex, requiredQuantity);
  }

  checkCart() {
    if (!this.form) return;

    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log('Cart items:', cart.items);
      
      if (cart.status) {
        console.error('Cart error:', cart.description);
        return;
      }

      const hasGift = this.validateGiftItem(cart.items, this.getProduct);
      const hasRequired = this.validateRequiredItem(cart.items, this.buyProduct);

      console.log('Has gift:', hasGift, 'Has required:', hasRequired);

      if (!hasGift) {
        if(hasRequired) {  
          console.log('Adding gift to cart');
          this.addGiftToCart();
          if(this.getRequiredQuantity(cart.items, this.buyProduct) != 1){
            this.updateMinBogoQuantity(cart.items);
          }                      
          return;
        }
      } else {
        if(hasRequired) {
          const giftItem = cart.items.find(line_item => line_item.id == this.getProduct && line_item.final_line_price === 0);
          const equalQuantity = giftItem && giftItem.quantity == this.getRequiredQuantity(cart.items, this.buyProduct);
          !equalQuantity ? this.updateMinBogoQuantity(cart.items) : true;
        } else {
          console.log('Removing gift from cart');
          const giftItemIndex = this.getGiftItemIndex(cart.items, this.getProduct);
          this.cartItems.updateQuantity(giftItemIndex, 0);
          return;
        }
      }
    })
    .catch(e => {
      console.error('Error checking cart:', e);
    });
  }

  addGiftToCart() {
    if (!this.form) return;

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    config.body = formData;

    if (this.cartItems) {
      formData.append('sections', this.cartItems.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    } else {
      formData.append('sections', this.getCartIconBubbleSectionToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }

    fetch(`${routes.cart_add_url}`, config)
    .then(response => { return response.text(); })
    .then(state => {
      const parsedState = JSON.parse(state);
      console.log('Gift added successfully');

      this.cartItems.getSectionsToRender().forEach((section => {
        const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
        this.cartItems.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      this.cartItems.disableLoading();
    })
    .catch(e => {
      console.error('Error adding gift:', e);

      if (!this.cartItems) return;
      this.cartItems.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      document.getElementById('cart-errors').textContent = window.cartStrings.error;
      this.cartItems.disableLoading();
    });
  }
}

customElements.define('buy-x-get-y', BuyXGetY);